import styles from './EmptyState.module.css';
import { classList } from '../../helpers/classList';

export interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  /** Defaults to a magnifier, which is right for a filtered list. */
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

const SearchIcon = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden
  >
    <circle cx='11' cy='11' r='7' />
    <path d='M20 20l-3.5-3.5' />
  </svg>
);

export const EmptyState = ({ title, description, icon, action, className }: EmptyStateProps) => (
  <div className={classList(styles.empty, className)}>
    <div className={styles.art}>{icon ?? <SearchIcon />}</div>
    <p className={styles.title}>{title}</p>
    {description && <p className={styles.body}>{description}</p>}
    {action && <div className={styles.action}>{action}</div>}
  </div>
);
